export const TOKEN_SESSION_KEY = 'TOKEN';

export const LATITUDE = 'latitude';

export const LONGITUDE = 'longitude';

export const LANGUAGE = 'LANGUAGE';

export const REDIRECT_URI_DEEPLINK = 'redirectURIDeeplink';

export const LOCALE = 'locale';

export const CLIENT_NAME = {
	TWELVE_PC: '12% CLUB',
	TWELVE_PC_LDC: '12% CLUB ADD MONEY LDC',
	TP_CLUB_ADD_MONEY_LDC: 'TP_CLUB_ADD_MONEY_LDC',
	TP_CLUB_ADD_MONEY_LL: 'TP_CLUB_ADD_MONEY_LL',
	TP_CLUB_LOAN_REPAYMENT_LDC: 'TP_CLUB_LOAN_REPAYMENT_LDC',
	TP_CLUB_LOAN_REPAYMENT_LL: 'TP_CLUB_LOAN_REPAYMENT_LL',
	MERCHANT: 'merchant',
	POSTPE: 'POSTPE',
	UNITY: 'UNITY_BANK',
	BHARAT_SWIPE: 'BHARATSWIPE',
	DEPOSIT: 'DEPOSIT',
	TPCLUB_ADD_MONEY: 'TPCLUB_ADD_MONEY',
};
export const PERMISSIONS: string[] = ['SEND_SMS', 'READ_PHONE_STATE', 'READ_SMS'];

export const APPLICATION_NAME = {
	BHARATPE: 'BHARATPE',
	TPCLUB: 'TPCLUB',
	POSTPE: 'POSTPE',
	ZILLION: 'PAYBACK',
	UNITY_BANK: 'UNITY_BANK',
};

export const IOS_JUSPAY_APP_VERSIONS = {
	POSTPE: '113',
	TPCLUB: '106',
	BHARATPE: '254',
};

export const ANDROID_JUSPAY_APP_VERSIONS = {
	POSTPE: '125',
	TPCLUB: '120',
	BHARATPE: '325',
};

export const enum UPISteps {
	UPGRADE = 'upgrade',
	REACTIVATE = 'reactivate',
	UPI_ONBOARDING_COMPLETE = 'onboardingComplete',
	PAYMENT_METHOD = 'paymentMethod',
	BANK_SCREEN = 'bankScreen',
	UPI_MANDATE = 'upiMandate',
	RECLAIM_STATUS = 'reclaimStatus',
}

export const enum ONBOARDING_REDIRECTION_PAGE {
	PROFILE = 'profile',
	MANDATE = 'mandate',
}

export const UPI_ERROR_CODE = [
	'CI',
	'DF',
	'DT',
	'HS',
	'IC',
	'ID',
	'IE',
	'IR',
	'K1',
	'LC',
	'LD',
	'NO',
	'PS',
	'QU',
	'UA',
	'UB',
	'UP',
	'VA',
	'VB',
	'VC',
	'VD',
	'VE',
	'VF',
	'VG',
	'VH',
	'VI',
	'VJ',
	'VK',
	'VL',
	'VM',
	'VO',
	'VP',
	'VQ',
	'VR',
	'VS',
	'VT',
	'VU',
	'VY',
	'VZ',
	'X6',
	'X7',
	'XB',
	'XC',
	'XD',
	'XE',
	'XF',
	'XG',
	'XH',
	'XI',
	'XJ',
	'XK',
	'XL',
	'XM',
	'XN',
	'XO',
	'XP',
	'XQ',
	'XR',
	'XS',
	'XT',
	'XU',
	'XV',
	'XW',
	'XX',
	'XY',
	'Y1',
	'YA',
	'YB',
	'YC',
	'YD',
	'YE',
	'YF',
	'YH',
	'YI',
	'Z5',
	'Z6',
	'Z7',
	'Z8',
	'Z9',
	'ZC',
	'ZD',
	'ZF',
	'ZI',
	'ZJ',
	'ZK',
	'ZL',
	'ZM',
	'ZN',
	'ZO',
	'ZP',
	'ZQ',
	'ZR',
	'ZS',
	'ZT',
	'ZU',
	'ZV',
	'ZX',
	'ZY',
	'FL',
	'FP',
	'MR',
	'MB',
	'AJ',
	'AM',
	'B2',
	'B3',
	'B7',
	'BR',
	'HS',
	'IR',
	'LC',
	'LD',
	'RM',
	'RN',
	'RZ',
	'SP',
	'VN',
	'XH',
	'XL',
	'XN',
	'XR',
	'Z6',
	'ZM',
	'ZR',
	'ZS',
	'ZT',
];

export const MODULE_DEEPLINKS = {
	PROFILE_PROD: 'bharatpe://dynamic?key=merchant-app-common&wroute=profile',
	PROFILE_QA: 'bharatpe://dynamic?key=merchant-app-common-qa&wroute=profile',
	PROFILE_DEV: 'bharatpe://dynamic?key=merchant-app-common-dev&wroute=profile',
	PROFILE_UAT: 'bharatpe://dynamic?key=merchant-app-common-uat&wroute=profile',
};
